import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const state = {
  lecturas: Array(150).fill("0000"),
};

export default new Vuex.Store({
  state,
});
